import { render, staticRenderFns } from "./GroupCommentForm.vue?vue&type=template&id=26bc7ab8&scoped=true"
import script from "./GroupCommentForm.vue?vue&type=script&lang=js"
export * from "./GroupCommentForm.vue?vue&type=script&lang=js"
import style0 from "./GroupCommentForm.vue?vue&type=style&index=0&id=26bc7ab8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc7ab8",
  null
  
)

export default component.exports